import { Container, Form, FormText, Input, Label } from "reactstrap";
import React from "react";
// import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import "./App.css";
import "../share/form.css"
// import { Loading } from "../share/loading";
import Swal from "sweetalert2";
// import { NumericFormat } from 'react-number-format';
import { Lock, User2, Mail } from 'lucide-react';

export function RePasswordComponent() {

    const initialValues = {
        username: "",
        email: "",
        password: "",
        cpassword: ""
    }
    const onSubmit = async (values, actions) => {
        try {
            let res = await fetch("/api/Users/RepasswordData",
                {
                    method: "POST",
                    headers: { "Content-type": "application/json" },
                    body: JSON.stringify(values)
                });
            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "เปลี่ยนรหัสผ่านสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง"
                })
            } else {
                Swal.fire({
                    icon: "error",
                    title: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
                    text: "เนื่องจากไม่พบบัญชีผู้ใช้หรืออีเมลนี้",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง"
                })
            }
        } catch (e) {
            console.log(e)
        }
    }

    const validate = values => {
        let errors = {}
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        if (!values.username) {
            errors.username = "กรุณากรอกบัญชีผู้ใช้"
        }
        if (!values.email) {
            errors.email = "กรุณากรอกอีเมล"
        }
        if (!values.password) {
            errors.password = "กรุณากรอกรหัสผ่าน"
        } else if (values.password.length < 8) {
            errors.password = "รหัสผ่านต้องมีจำนวนอย่างน้อย 8 ตัวอักษร"
        } else if (!passwordRegex.test(values.password)) {
            errors.password = "รหัสผ่านต้องประกอบไปด้วย ตัวพิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข"
        }
        if (!values.cpassword) {
            errors.cpassword = "โปรดระบุยืนยันรหัสผ่าน"
        } else if (values.password !== values.cpassword) {
            errors.cpassword = "รหัสผ่านไม่ตรงกัน"
        }

        return errors
    }

    // validate โดยใช้ formik
    const formik = useFormik({
        enableReinitialize: true,
        initialValues,
        validate,
        onSubmit,
    })

    const handleSubmit = (e) => {
        e.preventDefault();
        if (Object.keys(formik.errors).length > 0) {
            // form has errors
            let errorText = "";
            for (const error in formik.errors) {
                errorText += `<h6>${formik.errors[error]}</h6>`;
            }
            Swal.fire({
                icon: 'error',
                title: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
                html: errorText,
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
            // set invalid state of form inputs
            for (const field in formik.errors) {
                formik.setFieldTouched(field, true);
            }
        } else {
            formik.handleSubmit(e);
        }
    }

    return (
        <Container className="d-flex justify-content-center align-item-center mb-5">
            <div className="form-border">
                <Form onSubmit={handleSubmit} autoComplete="off">
                    <div className="d-flex flex-column align-items-center justify-content-center my-5">
                        <div className="modal-body login-style p-0 mb-3">
                            <Label>บัญชีผู้ใช้ : {formik.touched.username && formik.errors.username ? <span className="text-left text-danger">{formik.errors.username}</span> : null}</Label>
                            <User2 color="#0A66C2" className="img-item-key" />
                            {/* <img className="img-item-user" alt="img-user" src="/images/User.png" /> */}
                            <Input
                                type="text"
                                className={
                                    formik.touched.username && formik.errors.username ?
                                        "input-error input-color rounded-pill" : "rounded-pill text-center input-color"
                                }
                                name="username"
                                id="username"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.username}
                            />
                            <FormText className="">เลขที่สถานประกอบกิจการ/เลขประจำตัวประชาชน/เลขที่ทะเบียนนิติบุคคล</FormText>
                        </div>
                        <div className="modal-body login-style p-0 mb-3">
                            <Label>อีเมล : {formik.touched.email && formik.errors.email ? <span className="text-left text-danger">{formik.errors.email}</span> : null}</Label>
                            <Mail color="#0A66C2" className="img-item-key" />
                            <Input
                                type="text"
                                className={
                                    formik.touched.email && formik.errors.email ?
                                        "input-error input-color rounded-pill " : "rounded-pill text-center input-color"
                                }
                                // placeholder="อีเมล"
                                name="email"
                                id="email"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.email}
                            />
                            {/* {formik.touched.email && formik.errors.email ? <span className="text-left text-danger px-3">{formik.errors.email}</span> : null} */}
                        </div>
                        <div className="modal-body login-style p-0 mb-3">
                            {/* <img className="img-item-key" alt="img-key" src="/images/Key.png" /> */}
                            <Label>รหัสผ่าน (ตั้งรหัสผ่านใหม่) : {formik.touched.password && formik.errors.password ? <span className="text-left text-danger">{formik.errors.password}</span> : null}</Label>
                            <Lock color="#0A66C2" className="img-item-key" />
                            <Input
                                type="text"
                                className={
                                    formik.touched.password && formik.errors.password ?
                                        "input-error input-color rounded-pill " : "rounded-pill text-center input-color"
                                }
                                // placeholder="รหัสผ่าน(ตั้งรหัสผ่านใหม่)"
                                name="password"
                                id="password"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.password}
                            />
                            {/* {formik.touched.password && formik.errors.password ? <span className="text-left text-danger px-3">{formik.errors.password}</span> : null} */}
                        </div>
                        <div className="modal-body login-style p-0 mb-3">
                            <Label>ยืนยันรหัสผ่านใหม่ : {formik.touched.cpassword && formik.errors.cpassword ? <span className="text-left text-danger">{formik.errors.cpassword}</span> : null}</Label>
                            {/* <img className="img-item-key" alt="img-key" src="/images/Key.png" /> */}
                            <Lock color="#0A66C2" className="img-item-key" />
                            <Input
                                type="text"
                                className={
                                    formik.touched.cpassword && formik.errors.cpassword ?
                                        "input-error input-color rounded-pill " : "rounded-pill text-center input-color"
                                }
                                // placeholder="ยืนยันรหัสผ่านใหม่"
                                name="cpassword"
                                id="cpassword"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.cpassword}
                            />
                            {/* {formik.touched.cpassword && formik.errors.cpassword ? <span className="text-left text-danger px-3">{formik.errors.cpassword}</span> : null} */}
                        </div>
                        <button type="submit" className="btn-blue w-25 mt-4">เปลี่ยนรหัสผ่าน</button>
                    </div>

                </Form>
            </div>
        </Container>
    );
}